import {appConfig} from '@stencil/hotels-config';

const {searchWidgetId, detailsNavigationElementId} = appConfig;

export const getStickyOffsetY = () => {
  const searchWidgetHeight = document.getElementById(searchWidgetId)?.offsetHeight;
  const navigationHeaderHeight = document.getElementById(detailsNavigationElementId)?.offsetHeight;

  // write detailed comment here about what is happening
  const stickyOffsetY =
    searchWidgetHeight && navigationHeaderHeight
      ? searchWidgetHeight + navigationHeaderHeight
      : 149; // this is a manually calculated safe magic number, leave it be

  return stickyOffsetY;
};

export default getStickyOffsetY;
